const main = {
  state: {
    test: 1
  },
  mutations: {
    SET_TEST: (state, test) => {
      state.test = test
    }
  },
  actions: {
    UpdateTest({ commit }, test) {
      commit('SET_TEST', test)
    }
  }
}

export { main }



// WEBPACK FOOTER //
// ./src/store/modules/main.js